import moment from 'moment';

export const DEFAULT_TIMEZONE = '+03:00';

export const TIMEZONES = [
  { value: '+02:00', label: 'Калининград (UTC+2)' },
  { value: '+03:00', label: 'Москва (UTC+3)' },
  { value: '+04:00', label: 'Самара (UTC+4)' },
  { value: '+05:00', label: 'Екатеринбург (UTC+5)' },
  { value: '+06:00', label: 'Омск (UTC+6)' },
  { value: '+07:00', label: 'Красноярск (UTC+7)' },
  { value: '+08:00', label: 'Иркутск (UTC+8)' },
  { value: '+09:00', label: 'Якутск (UTC+9)' },
  { value: '+10:00', label: 'Владивосток (UTC+10)' },
  { value: '+11:00', label: 'Магадан (UTC+11)' },
  { value: '+12:00', label: 'Петропавловск-Камчатский (UTC+12)' },
];

export const getBrowserTimeZone = (): string => {
  const offsetMinutes = -new Date().getTimezoneOffset();
  const sign = offsetMinutes < 0 ? '-' : '+';
  const hours = String(Math.floor(Math.abs(offsetMinutes) / 60)).padStart(2, '0');
  const minutes = String(Math.abs(offsetMinutes) % 60).padStart(2, '0');
  const value = `${sign}${hours}:${minutes}`;

  return TIMEZONES.some((zone) => zone.value === value) ? value : DEFAULT_TIMEZONE;
};

export const nowInTimeZone = (timezone?: string) =>
  timezone ? moment().utcOffset(timezone) : moment();
